// Filename: public/quizLabelManager.js

import { setContactLabel, createLabel } from 'backend/userContact';
import { local } from "wix-storage-frontend";

export async function handleQuizTakenLabel(quizItem, wixUsers) {
    try {
        const labelSlug = `${generateLabelSlug(quizItem)}-taken`;
        const fullLabel = `custom.${labelSlug}`;

        // Assign label based on user login state
        if (wixUsers.loggedIn) {
            setContactLabel(wixUsers.id, [fullLabel]);
            //console.log(`${labelName} ...Label has been assigned.`);
        } else {
            local.setItem("quizTakenLabel", labelSlug);
        }

    } catch (err) {
        console.error(`Handling label for ${quizItem.title} failed:`, err);
    }
}

export async function assignStoredLabelToUser(currentMemberData) {
    const labelSlug = local.getItem("quizTakenLabel");

    if (!labelSlug) return;

    try {
        const fullLabel = `custom.${labelSlug}`;
        setContactLabel(currentMemberData._id, [fullLabel]);
        //console.log(`Label "${quizTakenLabel}" assigned to user ${currentMemberData._id}`);
        local.removeItem("quizTakenLabel");
    } catch (err) {
        console.error(`Failed to assign stored label "${labelSlug}" to user:`, err);
    }
}

export function generateLabelSlug(text) {
    return text
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '') // Remove non-word characters
        .replace(/[\s_-]+/g, '-') // Replace spaces, underscores, and multiple hyphens with a single hyphen
        .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
}